import React from "react";

// Pulse bar-chart mark (three rounded bars, tallest capped in green) — matches brand logo.
export const PulseMark = ({ size = 32, color = "#0A192F", className = "" }) => (
  <svg width={(size * 40) / 44} height={size} viewBox="0 0 40 44" fill="none"
       className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="1" y="24" width="9" height="19" rx="4.5" fill={color} />
    <rect x="15.5" y="15" width="9" height="28" rx="4.5" fill={color} />
    <rect x="30" y="15" width="9" height="28" rx="4.5" fill={color} />
    <path d="M30 16 L30 8.5 A4.5 4.5 0 0 1 34.5 4 A4.5 4.5 0 0 1 39 8.5 L39 16 Z" fill="#22C55E" />
  </svg>
);

export const Logo = ({ variant = "dark", withWord = true, size = 30, className = "" }) => {
  const isLight = variant === "light";
  const barColor = isLight ? "#FFFFFF" : "#0A192F";
  const wordColor = isLight ? "text-white" : "text-pulse-navy";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="pulse-logo">
      <PulseMark size={size} color={barColor} />
      {withWord && (
        <span className={`font-bold tracking-tight ${wordColor}`} style={{ fontSize: size * 0.72 }}>
          Pulse
        </span>
      )}
    </div>
  );
};

export default Logo;
